import React from 'react';
import { Avatar, AvatarSize } from '../../../../../../../../DesignSystem/VendorProfile/Avatar';

interface IProps {
  vendorName: string;
  supplierId: string;
}

const VENDOR_NAME_STYLE = 'pl-[5px] font-metricR text-sm text-bw08 leading-5';
export const VendorRenderer = ({ vendorName, supplierId }: IProps) => (
  <div className='flex pr-[5px] items-center' data-testid='BillsHub__table-column-vendor'>
    <Avatar name={vendorName} id={supplierId} size={AvatarSize.SMALL} />
    <div className={VENDOR_NAME_STYLE}>{vendorName}</div>
  </div>
);
